import { CalendarSlotDto } from '../model/fss.api';

export interface SlotCalendarDays {
  minDate: Date;
  maxDate: Date;
  disabledDates: Date[];
}

/**
 * Datepicker limits for a list of bookable days: only days that have a slot are selectable.
 * Until slots are loaded (or when there are none) only today is shown, and it is disabled —
 * with no min/max PrimeNG would let any day be picked, including past ones.
 */
export function slotCalendarDays(slots: CalendarSlotDto[]): SlotCalendarDays {
  if (slots.length === 0) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return { minDate: today, maxDate: today, disabledDates: [today] };
  }

  const times = slots.map((s) => s.dateTime!.getTime());
  const minDate = new Date(Math.min(...times));
  const maxDate = new Date(Math.max(...times));

  const available = new Set(slots.map((s) => dateKey(s.dateTime!)));
  const disabledDates: Date[] = [];
  for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
    if (!available.has(dateKey(d))) disabledDates.push(new Date(d));
  }

  return { minDate, maxDate, disabledDates };
}

function dateKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}
